<template>
    <div class="dml-banners" v-bind:class="bannerClassName" data-t="24.1">
        <div class="dml-banners__content">
            <a :href="url"
               :title="alt"
               class="dml-banners__media"
               :rel="rel"
               data-ga="m_home.click_ecommerce_banner"
               :data-ga-label="alt">
                <picture class="dml-banners__picture">
                    <source :data-srcset="largeSrcSet" media="(min-width: 1280px)">
                    <source :data-srcset="pictures.mediumx2" media="(min-width: 720px)">
                    <source :data-srcset="pictures.smallx2" media="(min-width: 361px)">
                    <img :data-srcset="smallSrcSet"
                         src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                         :alt="alt"
                         class="lazy" />
                </picture>
            </a>
            <div v-if="title" class="dml-banners__description">
                <p class="dml-banners__short-title" v-if="shortTitle">
                    <span>{{ shortTitle }}</span>
                </p>
                <h3>
                    <a :href="url" :rel="rel" class="dml-banners__title">
                        <span v-html="title" class="_dot"></span>
                        <dm-icon name="arrow-right" :width="24" :height="24" />
                    </a>
                </h3>
            </div>
        </div>
        <dm-scrollable-list className="dml-product-carousel"
                            innerClassName="dml-product-carousel__list"
                            navClassName="dml-product-carousel__nav"
                            :visibleIndicators="6"
                            :mobileItemsInViewport="2"
                            :tabletItemsInViewport="4"
                            :itemsInViewport="5">
            <template slot="items">
                <li class="dml-product-carousel__item"
                    v-for="(item, index) in productList"
                    :key="index"
                    data-ga="m_home.click_ecommerce_product"
                    :data-ga-label="alt">
                    <dm-product-item :model="item" />
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ProductItem from '../product-list/product-item-component';
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    const COMPONENTS = {
        0: 'text-on-photo',
        1: 'text-after-photo',
        2: 'products-on-photo'
    };

    export default {
        name: 'dm-products-banner',
        components: {
            'dm-product-item': ProductItem,
            'dm-icon': IconComponent,
            'dm-scrollable-list': ScrollableListComponent,
        },
        props: {
            bannerType: Number,
            pictures: Object,
            products: Array,
            rel: String,
            tabletImageUrl: String,
            tabletLargeImageUrl: String,
            title: String,
            shortTitle: String,
            url: String,
            urlLabel: String,
            alt: String,
        },
        computed: {
            bannerClassName() {
                return `dml-banners--${COMPONENTS[this.bannerType]}`;
            },
            productList() {
                return this.products.map(item => {
                    const props = {
                        price: item.priceText,
                        oldPrice: item.oldPriceText
                    };
                    return Object.assign({}, item, props);
                });
            },
            smallSrcSet() {
                return `${this.pictures.smallx2} 2x, ${this.pictures.smallx1} 1x`;
            },
            largeSrcSet() {
                return `${this.pictures.largex2} 2x, ${this.pictures.largex1} 1x`;
            },
        }
    };
</script>
